export default function mapVerifyOtpPayload(values) {
  return {
    email: values.email.trim().toLowerCase(),
    otp: values.otp.trim(),
    purpose: "login",
  };
}